import React from 'react';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import { AUTH_LEVELS } from '../../auth/Authorized';
import { getSelectedBuildingSummary } from '../../../redux/selectors/buildings';
import BreadCrumbs from '../breadcrumbs/BreadCrumbs';
import SummarySection from './SummarySection';
import Attachments from '../Attachments/Attachments';
import AttachmentUpload from '../Attachments/AttachmentUpload';
import SupportLink from '../../util/SupportLink';
import './BuildingSummary.css';

const BuildingSummary = ({ building, showStatus }) =>
  building ? (
    <div className="BuildingSummary">
      <div>
        {building.imgSrc && (
          <div className="BuildingSummary-image">
            <img src={building.imgSrc} alt="building" />
          </div>
        )}
        <div className="BuildingSummary-info-section">
          <Typography className="BuildingSummary-name" variant="h5">
            {building.name}
          </Typography>
          <div className="BuildingSummary-breadcrumbs">
            <BreadCrumbs />
          </div>
        </div>
        <SummarySection
          title="Building Summary"
          table={{
            Address: building.address,
            'Square Footage': building.sqFt?.toLocaleString(),
            '# Equipment Units': building.equipCount?.toLocaleString(),
            '# Data Points': building.pointCount?.toLocaleString(),
            ...(showStatus ? { Status: building.status } : {}),
          }}
        />
        <SummarySection
          title="BAS Information"
          table={{
            Manufacturer: building.bmsManufacturer,
            Name: building.bmsName,
            Version: building.bmsVersion,
          }}
        />
        <Attachments buildingId={building.id} />
        <AttachmentUpload buildingId={building.id} />
        <SupportLink />
      </div>
    </div>
  ) : null;

export default connect((state, { bid }) => ({
  building: getSelectedBuildingSummary(state, bid),
  showStatus: state.user.userAuthLevel <= AUTH_LEVELS.SUPER_ADMIN,
}))(BuildingSummary);
